import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
interface INotificationSlice {
    notificationUnreadCount: INotificationUnread;
    notifications: INotification[];
}

const initialState = {
    notificationUnreadCount: {
        alert: "0",
        warning: "0",
        info: "0",
        completed: "0",
        incomplete: "0",
        reminder: "0",
    },
    notifications: [],
} as INotificationSlice;

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        setNotification: (state, action: PayloadAction<INotification[]>) => {
            const set = {
                notificationUnreadCount: state.notificationUnreadCount,
                notifications: action.payload,
            };
            Object.assign(state, set);
        },
        prependNotification: (state, action: PayloadAction<INotification>) => {
            const set = {
                notificationUnreadCount: state.notificationUnreadCount,
                notifications: [action.payload, ...state.notifications],
            };
            Object.assign(state, set);
        },
        setNotificationUnreadCount: (state, action: PayloadAction<INotificationUnread>) => {
            Object.assign(state, { notificationUnreadCount: action.payload });
        },
        resetNotification: () => {
            return initialState;
        },
    },
});

export const { setNotification, resetNotification, prependNotification, setNotificationUnreadCount } =
    notificationSlice.actions;
export default notificationSlice.reducer;

export const getNotification = (state: RootState) => state.notification;
